import { truths } from "@/mocks/home";
import SectionHead from "./SectionHead";

export default function Truth() {
  return (
    <section id="truth" className="relative bg-background-950 py-20 md:py-28">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHead
          kicker="背后真相"
          title="不只听一面之词，把证据拼给你看"
          desc="真相往往藏在对账、截图与公开记录之间的缝隙里。每一篇我们都会标注深扒进度与已核实部分，读者可自行跟进求证。"
        />

        <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
          {truths.map((t) => (
            <article
              key={t.id}
              className="group flex cursor-pointer flex-col overflow-hidden rounded-2xl border border-background-800 bg-background-900 transition-colors hover:border-background-600"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={t.image}
                  alt={`吃瓜黑网深扒：${t.title}`}
                  title={`吃瓜黑网 ${t.title} 背后真相 知情人士线索整理`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-950/80 px-3 py-1 text-[11px] font-medium text-foreground-200 backdrop-blur">
                  {t.label}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-5 md:p-6">
                <h3 className="font-heading text-base font-bold leading-snug text-foreground-50 transition-colors group-hover:text-primary-300 md:text-lg">
                  {t.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-400">{t.summary}</p>

                <div className="mt-5">
                  <div className="mb-2 flex items-center justify-between text-xs">
                    <span className="text-foreground-500">深扒进度</span>
                    <span className="font-heading font-semibold text-primary-300">{t.progress}%</span>
                  </div>
                  <div className="h-1.5 w-full overflow-hidden rounded-full bg-background-700">
                    <div className="h-full rounded-full bg-gradient-to-r from-secondary-500 to-primary-400" style={{ width: `${t.progress}%` }}></div>
                  </div>
                </div>

                <div className="mt-5 flex items-center justify-between border-t border-background-800 pt-4 text-xs text-foreground-500">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-chat-3-line"></i> {t.comment.toLocaleString()} 讨论
                  </span>
                  <span className="flex items-center gap-1 text-accent-300 group-hover:text-accent-200">
                    继续深扒 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}